import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { LanguagesState, LanguagesStore } from './languages.store';

@Injectable({ providedIn: 'root' })
export class LanguagesQuery extends QueryEntity<LanguagesState> {
  constructor(protected store: LanguagesStore) {
    super(store);
  }
}
